import { render, staticRenderFns } from "./Duplicate.vue?vue&type=template&id=5aa513a8&scoped=true"
import script from "./Duplicate.vue?vue&type=script&lang=js"
export * from "./Duplicate.vue?vue&type=script&lang=js"
import style0 from "./Duplicate.vue?vue&type=style&index=0&id=5aa513a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa513a8",
  null
  
)

export default component.exports